import React from 'react';

import { css } from '@emotion/css';
import { theme } from 'theme';

import { Input, InputProps } from 'components/Input';

interface PositiveNumberInputProps extends Omit<InputProps, 'onChange'> {
  value?: number;
  disabled?: boolean;
  onChange: (value: number | undefined) => void;
  requiresInteger?: boolean;
  min?: number;
}

export const PositiveNumberInput = ({
  value,
  disabled,
  onChange,
  requiresInteger = false,
  min = 0,
  ...props
}: PositiveNumberInputProps) => {
  let errorMessage = '';

  if (value !== undefined && requiresInteger && !Number.isInteger(value)) {
    errorMessage = `Value must be an integer`;
  }

  if (value !== undefined && value < min) {
    errorMessage = `Value must be greater than or equal to ${min}`;
  }

  return (
    <div>
      <Input
        type="number"
        disabled={disabled}
        onChange={(ev) => {
          const currentInputValue = ev.currentTarget.value;
          const numericInputValue = currentInputValue === '' ? undefined : Number(currentInputValue);
          onChange(numericInputValue);
        }}
        onKeyDown={(ev) => {
          if (ev.key === '-' || ev.key === 'e' || ev.key === 'E') {
            // Prevent negative numbers (or just dashes) and scientific notation
            ev.preventDefault();
          }
        }}
        value={value}
        min={min}
        validate={() => !errorMessage}
        {...props}
      />
      {errorMessage && (
        <div
          className={css`
            color: ${theme.colors.danger[500]};
          `}
        >
          {errorMessage}
        </div>
      )}
    </div>
  );
};
